import styled, { css } from 'styled-components';
import { Colors } from '../../../theme';
import { MENU_LAYOUT } from '../types';
const desktopStyles = css `
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: ${(props) => (props.$layout === MENU_LAYOUT.Even ? '340px' : 'auto')};
  max-width: ${(props) => (props.$layout === MENU_LAYOUT.Even ? 'auto' : '580px')};

  .top {
    box-sizing: border-box;
    display: flex;
    flex: 1;
    padding: 8px 0;
  }

  .middle {
    box-sizing: border-box;
    display: flex;
  }

  .main {
    box-sizing: border-box;
    display: flex;
    flex: ${(props) => (props.$layout === MENU_LAYOUT.Even ? '1' : '0 1 auto')};
    flex-direction: column;
    padding: 16px 0;
    border-top: solid 1px ${Colors.black40};
  }

  .sidebar {
    box-sizing: border-box;
    flex: ${(props) => (props.$layout === MENU_LAYOUT.Even ? '1' : '0 0 200px;')};
    min-width: ${(props) => (props.$layout === MENU_LAYOUT.Even ? 'auto' : '200px')};
    max-width: ${(props) => (props.$layout === MENU_LAYOUT.Even ? 'auto' : '200px')};
    padding: ${(props) => (props.$layout === MENU_LAYOUT.Even ? '16px 0' : '16px 8px')};
    border-top: solid 1px ${Colors.black40};
    border-left: solid 1px ${Colors.black40};
  }

  .bottom {
    box-sizing: border-box;
    flex: 1;
    padding: 16px;
    border-top: solid 1px ${Colors.black40};
  }
`;
const mobileStyles = css `
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  min-width: ${(props) => (props.$layout === MENU_LAYOUT.Even ? '340px' : 'auto')};

  .top {
    box-sizing: border-box;
    padding: 0;
  }

  .main {
    box-sizing: border-box;
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 4px 0;
  }

  .sidebar {
    box-sizing: border-box;
    display: ${(props) => (props.$layout === MENU_LAYOUT.Even ? 'flex' : 'none')};
    flex: 1;
    flex-direction: column;
    padding: ${(props) => (props.$layout === MENU_LAYOUT.Even ? '16px 0' : '16px 8px')};
    border-left: solid 1px ${Colors.black40};
  }

  .bottom {
    box-sizing: border-box;
    display: ${(props) => (props.$layout === MENU_LAYOUT.Even ? 'flex' : 'none')};
    padding: 0 8px;

    &::before {
      display: flex;
      margin: 8px;
      content: '';
      border-bottom: solid 1px ${Colors.black40};
    }
  }
`;
export const Wrapper = styled.div `
  ${(props) => (props.$isMobile === true ? mobileStyles : desktopStyles)};
`;
//# sourceMappingURL=styles.js.map